import * as constant from './constant'
export const mutations = {
    [constant.MARKET_ACTIVE_ROUTE](state, payload) {
        if (payload) {
            state.marketActiveTab = payload
        }
    },
    [constant.SET_SHOW_FOOTER](state, payload) {
        state.showFooter = payload
    },
    [constant.MARKET_ACTIVE_ROUTE_CHILD](state, payload) {
        if (payload) state.marketActiveTabChild = payload
    },
}